// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 372 ? "soundwave" : chunkId) + "." + {"372":"64149bfc","698":"355fe821","941":"0e0753bc"}[chunkId] + ".js";
};